/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Viewer_Role_ParticipantInputs */



/**
* | output |
* | --- |
* | "Participant" |
*
* @param {Tournaments_Lib_Viewer_Role_ParticipantInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_viewer_role_participant = /** @type {((inputs?: Tournaments_Lib_Viewer_Role_ParticipantInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Viewer_Role_ParticipantInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teilnehmer")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Participant")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("参赛者")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("參賽者")
	if (locale === "ko") return /** @type {LocalizedString} */ ("참가자")
	return /** @type {LocalizedString} */ ("Participant")
});